import ShortCutDisplay from "../../../../src/components/ShortcutDisplay";
import rulers from "../../../../assets/images/docs/rulers.png";
import guides from "../../../../assets/images/docs/guides.png";
import grid from "../../../../assets/images/docs/grid.png";
import dotgrid from "../../../../assets/images/docs/dotgrid.png";
import columns from "../../../../assets/images/docs/columns.png";
import rows from "../../../../assets/images/docs/rows.png";
import measuredistance2 from "../../../../assets/videos/measure-distance2.mp4";
import measureoverlay from "../../../../assets/videos/docs/rulers/measure.mp4";
import areascreenshots from "../../../../assets/videos/blogs/pp30/areascreenshot.mp4";
import * as React from 'react';
export default {
  ShortCutDisplay,
  rulers,
  guides,
  grid,
  dotgrid,
  columns,
  rows,
  measuredistance2,
  measureoverlay,
  areascreenshots,
  React
};